import { Finding, UsageCheck } from './model';

const DIMENSION_PREFIX = 'dimension.';

function dimensionIdOf(finding: Finding): string | null {
  return finding.path?.startsWith(DIMENSION_PREFIX) ? finding.path.slice(DIMENSION_PREFIX.length) || null : null;
}

/** Dimension ids the findings and usage checks point at, to look their names up. */
export function dimensionIdsIn(findings: Finding[], usage: UsageCheck[] = []): string[] {
  const ids = [...findings.map(dimensionIdOf), ...usage.map(check => check.dimensionId)];
  return [...new Set(ids.filter((id): id is string => !!id))];
}

/** Swaps raw dimension ids in labels and messages for the dimension's name. */
export function withDimensionTitles(findings: Finding[], titles: Map<string, string>): Finding[] {
  return findings.map(finding => {
    const id = dimensionIdOf(finding);
    const title = id ? titles.get(id) : undefined;
    if (!id || !title) return finding;

    const swap = (text: string) => text.split(`${DIMENSION_PREFIX}${id}`).join(title).split(id).join(title);
    return { ...finding, label: title, message: swap(finding.message) };
  });
}

/** Names the dimension each usage check reads. */
export function usageWithDimensionTitles(usage: UsageCheck[], titles: Map<string, string>): UsageCheck[] {
  return usage.map(check => ({ ...check, label: titles.get(check.dimensionId) ?? check.label }));
}
